import React from "react";
import "./OxxoPaymentCode.css";
import { Grid, Typography, Paper, Box, Link } from '@material-ui/core';
import { useTranslation } from "react-i18next";


const OxxoPaymentCode = ({ jsonMail, jsonTextos, idioma, reference, tipo }) => {
  const { t } = useTranslation("inscripcion");
  var monto = 0;
  var orden = jsonMail.datos.order;
  var monedaBase = jsonMail.datos.monedaBase;
  for (var i in orden) {
    monto =
      monto + orden[i].unit_price * orden[i].quantity * monedaBase.cambioAPeso;
  }
  return (
    <Box p={2} style={{ color: '#000', fontFamily: 'Ubuntu, Helvetica, Arial, sans-serif' }}>
      <Typography
        variant="body2"
        align="center"
        style={{ fontSize: 13, lineHeight: '22px' }}
      >
        <span style={{ fontFamily: 'Arial, sans-serif' }}>
          {jsonTextos[idioma].postEvento[tipo]} BBBB
        </span>
      </Typography>

      <Paper elevation={3} style={{ marginTop: 16, padding: 16 }}>
        <Grid container spacing={2} direction="column">
          <Grid item>
            <Typography variant="subtitle2" align="center">
              {t("oxxoFicha.fichaDigital")}
            </Typography>
          </Grid>

          <Grid item container spacing={2} justify="center" alignItems="center">
            <Grid item xs={12} sm={4} style={{ textAlign: 'center' }}>
              <img
                src="https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/oxxo_brand%2Foxxopay_brand.png?alt=media&token=a855a8cf-817f-4036-a34a-ddf926e54fad"
                alt="OXXOPay"
                style={{ maxWidth: '100%', height: 'auto' }}
              />
            </Grid>

            <Grid item xs={12} sm={8} style={{ textAlign: 'center' }}>
              <Typography variant="subtitle1" gutterBottom>
                {t("oxxo.montoAPagar")}
              </Typography>
              <Typography variant="h5">
                ${monto} <sup>MXN</sup>
              </Typography>
              <Typography variant="body2">
                {t("oxxo.comisionAdicional")}
              </Typography>
            </Grid>
          </Grid>

          <Grid item style={{ textAlign: 'center' }}>
            <Typography variant="subtitle1">{t("oxxo.referencia")}</Typography>
            <Typography variant="h6" style={{ wordBreak: 'break-word' }}>
              {reference}
            </Typography>
          </Grid>

          <Grid item>
            <Typography variant="subtitle1">{t("oxxo.instrucciones")}</Typography>
            <ol style={{ paddingLeft: 20 }}>
              <li>
                {t("oxxo.paso1Prefijo")}
                <Link href="https://www.google.com.mx/maps/search/oxxo/" target="_blank" rel="noopener">
                  {t("oxxoFicha.encuentralaAqui")}
                </Link>.
              </li>
              <li>
                {t("oxxoFicha.pagoDeOxxopay")} <strong>OXXOPay</strong>.
              </li>
              <li>
                {t("oxxoFicha.instruccion3")}
              </li>
              <li>{t("oxxoFicha.instruccion4")}</li>
              <li>
                {t("oxxoFicha.comprobantePrefijo")}{' '}
                <strong>{t("oxxoFicha.conservaComprobante")}</strong>
              </li>
            </ol>
          </Grid>

          <Grid item>
            <Typography variant="caption" display="block">
              {t("oxxoFicha.footerPrefijo")} <strong>Dashport</strong> {t("oxxoFicha.footerSufijo")}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default OxxoPaymentCode;
